import React, { useState } from 'react';
import './Login.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AuthService from '../../services/auth.service';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('session') === 'expired') {
      setMessage('Αποσυνδεθήκατε λόγω λήξης συνεδρίας. Συνδεθείτε ξανά.');
    }
  }, [location.search]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('');

    AuthService.login(email, password).then(
      (response: any) => {
        console.log("LOGIN SUCCESS - Checking Admin Permissions...");
        
        // 1. Check response email (safest)
        const responseEmail = response.email ? response.email.toLowerCase() : '';
        const isResponseAdmin = responseEmail === 'admin@myft.gr';
        
        // 2. Check input email (fallback)
        const isInputAdmin = email.trim().toLowerCase() === 'admin@myft.gr';

        // 3. Check roles
        const hasAdminRole = response.roles && response.roles.includes('ROLE_ADMIN');

        if (hasAdminRole || isResponseAdmin || isInputAdmin) {
          console.log("User is Admin. Redirecting to /admin...");
          // Force a hard redirect to ensure we escape any routing loops or stale state
          window.location.href = '/admin';
        } else {
          console.log("User is Customer. Redirecting to /dashboard...");
          navigate('/dashboard');
        }
      },
      (error: any) => {
        const resMessage =
          error.message ||
          error.toString();

        setMessage(resMessage);
      }
    );
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Συνδεση</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Εισαγωγη email"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Κωδικος Προσβασης</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Εισαγωγη κωδικου"
              required
            />
          </div>
          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert" style={{color: 'red', marginBottom: '10px'}}>
                {message}
              </div>
            </div>
          )}
          <button type="submit" className="login-btn">Συνδεση</button>
        </form>
        <div className="login-footer">
            <p>Δεν εχετε λογαριασμο; <Link to="/signup">Εγγραφη</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Login;
